// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1aLIK","file":"styles_file__1TNZN"};